import Icon from '../Icon';
import styled from 'styled-components';

export const Caption = styled.div`
  font-size: 13px;
  color: var(--carbone70);
  margin-right: 14px;
`;

export const TextInner = styled.div`
  max-width: 260px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;

  @media (orientation: landscape) and (max-width: 1030px) {
    html.zoom-lg & {
      max-width: 50px;
    }
  }
`;

export const ArrowBold = styled(Icon)`
  font-size: 8px;
  transition: var(--regularTransition);
`;

export const Value = styled.div`
  display: flex;
  align-items: center;
  font-size: ${props => (props.fontSize ? props.fontSize : '15px')};
  line-height: 1.33em;
  cursor: pointer;
  color: ${props =>
    props.valColor ? props.valColor.text : 'var(--carbone100)'};

  .icon {
    margin-left: 4px;
    color: ${props =>
      props.valColor ? props.valColor.icon : 'var(--carbone100)'};
  }

  .icon_tiny {
    width: 12px;
  }
`;

export const Select = styled.div`
  position: relative;
`;

export const Overlay = styled.div`
  display: none;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  z-index: 1;
`;

export const ItemIcon = styled(Icon)`
  width: 12px;
  opacity: 0;
  position: absolute;
  right: -4px;
  margin: 0;
`;

export const Link = styled.a`
  display: block;
  font-size: 13px;
  color: var(--carbone80);
  text-decoration: none;
  cursor: pointer;

  &:hover {
    color: var(--carbone80);
  }
`;

export const Item = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  font-size: ${props => (props.fontSize ? props.fontSize : '15px')};
  line-height: 1.33em;
  color: var(--carbone80);
  padding: 10px 40px 10px 15px;
  cursor: pointer;

  &[disabled] {
    pointer-events: none;
    color: var(--aluminium100);
  }

  svg {
    flex-shrink: 0;
    margin-right: 12px;
  }

  &:not(:last-child) {
    border-bottom: 1px solid var(--aluminium20);
  }

  &.active {
    ${Link} {
      color: var(--carbone120);
      font-weight: 500;
    }

    ${ItemIcon} {
      opacity: 1;
    }
  }

  &:hover,
  &.is-highlighted {
    background: var(--aluminium10);
  }
`;

export const IconHolder = styled.div`
  display: flex;
  align-items: center;
  margin-right: 13px;
`;

export const List = styled.div`
  display: none;
  position: absolute;
  box-shadow: 0px 3px 18px rgba(0, 0, 0, 0.04);
  border: 1px solid var(--aluminium35);
  border-radius: 4px;
  top: 31px;
  left: -16px;
  z-index: 10;
  background: #fff;
  min-width: 233px;
  max-height: 220px;
  overflow: auto;

  &.highlighting {
    padding: 5px 0;

    ${ItemIcon} {
      right: 0;
    }

    ${Item} {
      padding: 5px 10px 5px 10px;
      border: 0;

      &:hover {
        background: var(--aluminium10);

        ${ItemIcon} {
          opacity: 0;
        }
      }
    }
  }

  @media (max-width: 767px) {
    top: auto;
    bottom: -25px;
    width: 160px;
    min-width: 0;
  }
`;

export const SearchWrapper = styled.div`
  padding: 8px 12px;
  border-bottom: 1px solid var(--aluminium20);
  background: #fff;
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 32px;
  border: 1px solid var(--aluminium35);
  border-radius: 4px;
  padding: 4px 10px;
  font-size: 13px;
  outline: none;

  &:focus {
    border-color: var(--theme-palette-brand-color);
  }
`;

export const NoResults = styled.div`
  padding: 12px 16px;
  font-size: 13px;
  color: var(--carbone70);
`;

export const Text = styled.div``;

export const Selecter = styled.div`
  position: relative;
  display: flex;
  align-items: center;

  &.selecter-open {
    ${List} {
      display: block;
    }

    ${ArrowBold} {
      transform: rotate(180deg);
    }

    ${Overlay} {
      display: block;
    }
  }
`;
